<template>
  <div>
    <notification-widget v-if="panel.panel_widget_id === 2" isCombo="true"></notification-widget>
    <upcoming-widget v-if="panel.panel_widget_id === 3" isCombo="true" :permissions="permissions"></upcoming-widget>
    <marketplace-widget v-if="panel.panel_widget_id === 4"></marketplace-widget>
    <dashboard-trackplus-cards :name="name" :panel="panel" v-if="[5,6,7].includes(panel.panel_widget_id)" isCombo="true"></dashboard-trackplus-cards>
    <expirtypending-component v-if="panel.panel_widget_id === 8" ></expirtypending-component>
    <template v-if="sbObj">
    <!-- <template> -->
      <due-date-widget v-if="panel.panel_widget_id === 10"  isCombo="true" :sbData="sbObj"></due-date-widget>
      <action-tracker v-if="panel.panel_widget_id === 11" isCombo="true" :sbData="sbObj"></action-tracker>
      <project-status Initialtitle="true" isCombo="true" v-if="panel.panel_widget_id === 12" :sbData="sbObj"></project-status>
      <project-type Initialtitle="true" :type="type" v-if="panel.panel_widget_id === 13" :sbData="sbObj"></project-type>
      <action-due-widgets v-if="panel.panel_widget_id === 14" :sbData="sbObj"></action-due-widgets>
      <project-type-status v-if="panel.panel_widget_id === 15" :sbData="sbObj"></project-type-status>
    </template>
    <template v-if="sxObj">
      <due-date-widget v-if="panel.panel_widget_id === 18"  isCombo="true" :sbData="sxObj" :isSX="true"></due-date-widget>
      <project-status Initialtitle="true" isCombo="true" v-if="panel.panel_widget_id === 17" :sbData="sxObj"  :isSX="true"></project-status>
    </template>
  </div>
</template>

<script>
import ActionDueWidgets from './SmartBuilderWidgets/ActionDueWidgets.vue';
import ProjectTypeStatus from './SmartBuilderWidgets/ProjectTypeStaus.vue';
import ProjectStatus from './SmartBuilderWidgets/ProjectStatus.vue';
import ProjectType from './SmartBuilderWidgets/ProjectType.vue';
import expiryComponent from './RegTrackerWidgets/ExpiryCardComponent.vue';
import pendingComponent from './RegTrackerWidgets/PendingCardComponent.vue';
import DashboardTrackplusCards from './RegTrackerWidgets/DashboardTrackplusCards.vue';
import NotificationWidget from './DashboardWidgets/NotificationWidget.vue';
import UpcomingWidget from './DashboardWidgets/UpcomingWidget.vue';
import expirtypendingComponent from './RegTrackerWidgets/ExpiryPendingCardComponent.vue';
import MarketplaceWidget from './DashboardWidgets/MarketplaceWidget.vue';
import ActionTracker from './SmartBuilderWidgets/ActionTracker.vue';
import DueDateWidget from './SmartBuilderWidgets/DueDateWidget.vue';

export default {
  name: 'ComboCardComponent',
  components: {
    ActionDueWidgets,
    ProjectTypeStatus,
    ProjectStatus,
    ProjectType,
    expirtypendingComponent,
    expiryComponent,
    pendingComponent,
    NotificationWidget,
    UpcomingWidget,
    MarketplaceWidget,
    ActionTracker,
    DueDateWidget,
    DashboardTrackplusCards,
  },
  props: ['panel', 'sbData', 'permissions', 'name', 'type', 'sxData'],
  data() {
    return {
      sbObj: null,
      sxObj: null,
    };
  },
  computed: {
  },
  watch: {
    sbData() {
      if (this.sbData) {
        this.sbObj = this.sbData;
      }
    },
    sxData() {
      if (this.sxData) {
        this.sxObj = this.sxData;
      }
    },
  },
  methods: {
  },
  created() {
  },
};
</script>
<style scoped>
</style>
